import { SVGProps, useMemo } from "react";

export const MenuIcon = (props: SVGProps<SVGSVGElement>) => {
  const color = useMemo(() => props?.color ?? "#000000", [props?.color]);

  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" fill="white" />
      <path d="M6 12H18" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 15.5H18" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 8.5H18" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
